exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SortOptionToggle__sortBtn___3Ny8n {\n  padding: 10px 0;\n  background-color: #ffffff;\n  border: 1px solid #bfbfbf;\n  box-sizing: border-box;\n  border-radius: 5px;\n  padding: 8px 8px;\n  display: inline-block;\n  margin-right: 15px;\n  transition: 300ms;\n  cursor: pointer; }\n  .SortOptionToggle__sortBtn___3Ny8n > img {\n    width: 20px;\n    vertical-align: middle; }\n  .SortOptionToggle__sortBtn___3Ny8n > span {\n    margin-left: 8px;\n    vertical-align: middle;\n    font-weight: 600;\n    font-size: 15px;\n    line-height: 23px;\n    color: #000000;\n    transition: 300ms; }\n  .SortOptionToggle__sortBtn___3Ny8n:hover {\n    filter: brightness(0.95); }\n    .SortOptionToggle__sortBtn___3Ny8n:hover span {\n      color: #ff7381; }\n", ""]);

// exports
exports.locals = {
	"sortBtn": "SortOptionToggle__sortBtn___3Ny8n"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/SortOption/SortOptionMobile/SortOptionToggle/styles/SortOptionToggle.scss
// module id = 4286
// module chunks = 6